import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';
const TIPOS = {
  call:     { label:'Call',      cor:'#6B2FA0', bg:'#f3e8ff', emoji:'📞' },
  followup: { label:'Follow-up', cor:'#d97706', bg:'#fef3c7', emoji:'🔄' },
  proposta: { label:'Proposta',  cor:'#0891b2', bg:'#e0f2fe', emoji:'📄' },
  reuniao:  { label:'Reunião',   cor:'#16a34a', bg:'#dcfce7', emoji:'👥' },
  tarefa:   { label:'Tarefa',    cor:'#4A90D9', bg:'#EBF4FF', emoji:'✅' },
  lembrete: { label:'Lembrete',  cor:'#E05454', bg:'#FEF2F2', emoji:'🔔' },
};
const meses = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
const diasSemana = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];

function iniciais(nome) { return (nome||'').split(' ').map(p=>p[0]).slice(0,2).join(''); }

export default function Agenda() {
  const { usuario } = useAuth();
  const perfilAtual = usuario?.perfil || 'sdr';
  const usuarioAtual = usuario?.nome || '';
  const isGestorAdmin = ['admin','gestor'].includes(perfilAtual);

  const [colaboradores, setColaboradores] = useState([]);
  const [projetosCad, setProjetosCad] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const hoje = new Date();
  const [mes, setMes] = useState(hoje.getMonth());
  const [ano, setAno] = useState(hoje.getFullYear());
  const [diaSelecionado, setDiaSelecionado] = useState(hoje.getDate());
  const [modalAberto, setModalAberto] = useState(false);
  const [eventoAberto, setEventoAberto] = useState(null);
  const [filtroResp, setFiltroResp] = useState('');
  const [filtroTipo, setFiltroTipo] = useState('');
  const [modalLembrete, setModalLembrete] = useState(false);
  const [modalEditarEvento, setModalEditarEvento] = useState(false);
  const [formEditar, setFormEditar] = useState({});
  const [form, setForm] = useState({ titulo:'', data:'', hora:'09:00', tipo:'call', responsaveis:[usuarioAtual], projeto:'', status:'Agendado', obs:'' });
  const [formLembrete, setFormLembrete] = useState({ titulo:'', data:'', hora:'09:00', obs:'', destinatario:'' });

  useEffect(() => {
    carregarEventos();
    supabase.from('colaboradores').select('nome, cor, nivel').order('nome').then(({ data }) => {
      if (data) setColaboradores(data);
    });
    supabase.from('projetos').select('id, nome').order('nome').then(({ data }) => {
      if (data) setProjetosCad(data);
    });
  }, []);

  async function carregarEventos() {
    setCarregando(true);
    const { data } = await supabase.from('agenda').select('*').order('data').order('hora');
    if (data) setEventos(data);
    setCarregando(false);
  }

  function dataStr(d) { return `${ano}-${String(mes+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`; }

  function eventosDoDia(dia) {
    const ds = dataStr(dia);
    return eventos.filter(e => {
      const respOk = !filtroResp || (e.responsaveis||[]).includes(filtroResp);
      const tipoOk = !filtroTipo || e.tipo === filtroTipo;
      return e.data === ds && respOk && tipoOk;
    }).sort((a,b) => (a.hora||'').localeCompare(b.hora||''));
  }

  function temEvento(dia) { return eventosDoDia(dia).length > 0; }

  async function salvarEvento() {
    if (!form.titulo || !form.data) return;
    const { data } = await supabase.from('agenda').insert([form]).select().single();
    if (data) setEventos([...eventos, data]);
    setModalAberto(false);
    setForm({ titulo:'', data:'', hora:'09:00', tipo:'call', responsaveis:[usuarioAtual], projeto:'', status:'Agendado', obs:'' });
  }

  async function mudarStatus(id, status) {
    const { data } = await supabase.from('agenda').update({ status }).eq('id', id).select().single();
    if (data) { setEventos(eventos.map(e => e.id===id?data:e)); setEventoAberto(ev => ev?.id===id?data:ev); }
  }

  async function salvarEdicaoEvento() {
    if (!formEditar.titulo) return;
    const { data } = await supabase.from('agenda').update(formEditar).eq('id', eventoAberto.id).select().single();
    if (data) { setEventos(eventos.map(e => e.id===eventoAberto.id?data:e)); setEventoAberto(data); }
    setModalEditarEvento(false);
  }

  async function enviarLembrete() {
    if (!formLembrete.titulo || !formLembrete.destinatario) return;
    const evento = { ...formLembrete, tipo:'lembrete', responsaveis:[formLembrete.destinatario], projeto:'', status:'Agendado', remetente:usuarioAtual };
    const { data } = await supabase.from('agenda').insert([evento]).select().single();
    if (data) setEventos([...eventos, data]);
    setModalLembrete(false);
    setFormLembrete({ titulo:'', data:'', hora:'09:00', obs:'', destinatario:'' });
  }

  function toggleResponsavel(nome) {
    const atual = form.responsaveis||[];
    setForm({ ...form, responsaveis: atual.includes(nome)?atual.filter(r=>r!==nome):[...atual, nome] });
  }

  function mesAnterior() { if(mes===0){setMes(11);setAno(ano-1);}else setMes(mes-1); }
  function proximoMes() { if(mes===11){setMes(0);setAno(ano+1);}else setMes(mes+1); }

  const corResp = (nome) => colaboradores.find(c=>c.nome===nome)?.cor||'#ccc';
  const inicialResp = (nome) => colaboradores.find(c=>c.nome===nome) ? iniciais(colaboradores.find(c=>c.nome===nome).nome) : (nome||'?')[0];
  const primeiroDia = new Date(ano, mes, 1).getDay();
  const diasNoMes = new Date(ano, mes+1, 0).getDate();

  return (
    <div>
      <div className="section-header"><h2 className="section-title">Agenda</h2><div className="section-line" /></div>

      <div className="filter-bar">
        {isGestorAdmin && (
          <select value={filtroResp} onChange={e => setFiltroResp(e.target.value)} className={`chip-select${filtroResp?' active':''}`}>
            <option value=''>Colaborador</option>
            {colaboradores.map(c => <option key={c.nome} value={c.nome}>{c.nome}</option>)}
          </select>
        )}
        <select value={filtroTipo} onChange={e => setFiltroTipo(e.target.value)} className={`chip-select${filtroTipo?' active':''}`}>
          <option value=''>Tipo</option>
          {Object.entries(TIPOS).map(([k,v]) => <option key={k} value={k}>{v.emoji} {v.label}</option>)}
        </select>
        {(filtroResp||filtroTipo) && (
          <button onClick={() => { setFiltroResp(''); setFiltroTipo(''); }} style={{ padding:'7px 12px', border:'none', borderRadius:10, background:'#F3EBFF', color:'#7B2FBE', cursor:'pointer', fontSize:12, fontWeight:600, fontFamily:'Poppins,sans-serif' }}>✕ Limpar</button>
        )}
        <div style={{ flex:1 }} />
        {isGestorAdmin && <button onClick={() => setModalLembrete(true)} style={{ padding:'8px 16px', borderRadius:10, border:'1.5px solid rgba(220,38,38,0.3)', background:'#FEF2F2', color:'#dc2626', cursor:'pointer', fontSize:12.5, fontWeight:600, fontFamily:'Poppins,sans-serif' }}>🔔 Lembrete</button>}
        <button onClick={() => { setForm({ titulo:'', data:dataStr(diaSelecionado), hora:'09:00', tipo:'call', responsaveis:[usuarioAtual], projeto:'', status:'Agendado', obs:'' }); setModalAberto(true); }}
          style={{ background:'linear-gradient(135deg,#b45309,#D4AF37)', color:'white', border:'none', padding:'9px 22px', borderRadius:10, fontWeight:700, cursor:'pointer', fontSize:13, fontFamily:'Poppins,sans-serif', boxShadow:'0 4px 14px rgba(180,83,9,0.3)' }}>
          + Evento
        </button>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 380px', gap:20 }}>
        <div className="card" style={{ padding:24 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
            <button onClick={mesAnterior} style={{ background:'transparent', border:'1px solid var(--border)', borderRadius:6, padding:'6px 14px', cursor:'pointer', color:'var(--text-secondary)', fontSize:16 }}>‹</button>
            <span style={{ fontWeight:700, fontSize:16, color:'var(--text-primary)' }}>{meses[mes]} {ano}</span>
            <button onClick={proximoMes} style={{ background:'transparent', border:'1px solid var(--border)', borderRadius:6, padding:'6px 14px', cursor:'pointer', color:'var(--text-secondary)', fontSize:16 }}>›</button>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:2, marginBottom:8 }}>
            {diasSemana.map(d => <div key={d} style={{ textAlign:'center', fontSize:11, fontWeight:700, color:'var(--gray-400)', padding:'4px 0' }}>{d}</div>)}
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:2 }}>
            {Array.from({length:primeiroDia}).map((_,i) => <div key={`v${i}`} />)}
            {Array.from({length:diasNoMes}).map((_,i) => {
              const dia = i+1;
              const ehHoje = dia===hoje.getDate()&&mes===hoje.getMonth()&&ano===hoje.getFullYear();
              const selecionado = dia===diaSelecionado;
              const evs = eventosDoDia(dia);
              return (
                <div key={dia} onClick={() => setDiaSelecionado(dia)}
                  style={{ aspectRatio:'1', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', borderRadius:8, cursor:'pointer', position:'relative', gap:2,
                    background:selecionado?'var(--purple)':ehHoje?'#f3e8ff':'transparent',
                    color:selecionado?'white':ehHoje?'var(--purple)':'var(--text-primary)',
                    fontWeight:ehHoje||selecionado?700:400, fontSize:13 }}>
                  {dia}
                  {evs.length>0 && <div style={{ display:'flex', gap:2 }}>{evs.slice(0,3).map((e,ei) => <div key={ei} style={{ width:5, height:5, borderRadius:'50%', background:selecionado?'white':(TIPOS[e.tipo]?.cor||'var(--gold)') }} />)}</div>}
                </div>
              );
            })}
          </div>
          <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginTop:16, paddingTop:12, borderTop:'1px solid var(--border)' }}>
            {Object.entries(TIPOS).map(([k,v]) => <div key={k} style={{ display:'flex', alignItems:'center', gap:4 }}><div style={{ width:8, height:8, borderRadius:'50%', background:v.cor }} /><span style={{ fontSize:11, color:'var(--gray-400)' }}>{v.label}</span></div>)}
          </div>
        </div>

        <div>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
            <span style={{ fontWeight:700, fontSize:15, color:'var(--text-primary)' }}>{diaSelecionado} de {meses[mes]}</span>
            <span style={{ fontSize:12, color:'var(--gray-400)' }}>{eventosDoDia(diaSelecionado).length} evento(s)</span>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {eventosDoDia(diaSelecionado).length===0 && (
              <div className="card" style={{ padding:24, textAlign:'center', color:'var(--gray-400)', fontSize:13 }}>
                Nenhum evento neste dia.
                <br />
                <button onClick={() => { setForm({ titulo:'', data:dataStr(diaSelecionado), hora:'09:00', tipo:'call', responsaveis:[usuarioAtual], projeto:'', status:'Agendado', obs:'' }); setModalAberto(true); }}
                  style={{ marginTop:10, background:'var(--purple)', color:'white', border:'none', padding:'7px 16px', borderRadius:6, cursor:'pointer', fontSize:12, fontWeight:600 }}>
                  + Adicionar evento
                </button>
              </div>
            )}
            {eventosDoDia(diaSelecionado).map(ev => {
              const tc = TIPOS[ev.tipo]||TIPOS.call;
              return (
                <div key={ev.id} className="card" onClick={() => setEventoAberto(ev)}
                  style={{ padding:14, borderLeft:`3px solid ${tc.cor}`, cursor:'pointer' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:6 }}>
                    <span style={{ fontWeight:700, fontSize:13, color:'var(--text-primary)' }}>{tc.emoji} {ev.titulo}</span>
                    <span style={{ fontSize:13, fontWeight:700, color:tc.cor }}>{ev.hora}</span>
                  </div>
                  <div style={{ display:'flex', gap:6, alignItems:'center', flexWrap:'wrap' }}>
                    <span style={{ background:tc.bg, color:tc.cor, padding:'2px 8px', borderRadius:20, fontSize:10, fontWeight:700 }}>{tc.label}</span>
                    {ev.projeto && <span style={{ fontSize:11, color:'var(--gray-400)' }}>{ev.projeto}</span>}
                    <span style={{ fontSize:11, fontWeight:600, color:ev.status==='Realizado'?'#16a34a':ev.status==='No-show'?'#E05454':'var(--gray-400)' }}>{ev.status}</span>
                  </div>
                  <div style={{ display:'flex', gap:4, marginTop:8 }}>
                    {(ev.responsaveis||[]).map(r => <div key={r} title={r} style={{ width:20, height:20, borderRadius:'50%', background:corResp(r), display:'flex', alignItems:'center', justifyContent:'center', fontSize:8, fontWeight:700, color:'white' }}>{inicialResp(r)}</div>)}
                    {ev.remetente && <span style={{ fontSize:10, color:'#E05454', fontWeight:600 }}>de {ev.remetente}</span>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Painel detalhe evento */}
      {eventoAberto && (
        <div style={{ position:'fixed', inset:0, zIndex:1000, display:'flex' }}>
          <div style={{ flex:1, background:'rgba(0,0,0,0.4)' }} onClick={() => setEventoAberto(null)} />
          <div style={{ width:440, background:'#ffffff', borderLeft:'1px solid var(--border)', overflowY:'auto', padding:28, boxShadow:'-4px 0 24px rgba(0,0,0,0.15)' }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:20 }}>
              <h3 style={{ margin:0, color:TIPOS[eventoAberto.tipo]?.cor||'var(--purple)', fontSize:17 }}>{TIPOS[eventoAberto.tipo]?.emoji} {eventoAberto.titulo}</h3>
              <div style={{ display:'flex', gap:8 }}>
                <button onClick={() => { setFormEditar({...eventoAberto}); setModalEditarEvento(true); }}
                  style={{ background:'var(--purple)', color:'white', border:'none', padding:'6px 14px', borderRadius:6, cursor:'pointer', fontSize:12, fontWeight:600 }}>Editar</button>
                <button onClick={() => setEventoAberto(null)} style={{ background:'transparent', border:'none', fontSize:20, cursor:'pointer', color:'var(--gray-400)' }}>×</button>
              </div>
            </div>
            <div className="card" style={{ padding:16, marginBottom:14 }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                {[{label:'Data',val:eventoAberto.data},{label:'Hora',val:eventoAberto.hora},{label:'Tipo',val:TIPOS[eventoAberto.tipo]?.label},{label:'Projeto',val:eventoAberto.projeto||'—'}].map(f => (
                  <div key={f.label}><div style={{ fontSize:10, color:'var(--gray-400)', marginBottom:2, textTransform:'uppercase', fontWeight:600 }}>{f.label}</div><div style={{ fontSize:13, color:'var(--text-primary)', fontWeight:500 }}>{f.val}</div></div>
                ))}
              </div>
            </div>
            {eventoAberto.obs && <div className="card" style={{ padding:14, marginBottom:14 }}><div style={{ fontSize:10, fontWeight:600, color:'var(--gray-400)', marginBottom:6, textTransform:'uppercase' }}>Observações</div><div style={{ fontSize:13, color:'var(--text-secondary)' }}>{eventoAberto.obs}</div></div>}
            <div className="card" style={{ padding:14, marginBottom:14 }}>
              <div style={{ fontSize:10, fontWeight:600, color:'var(--gray-400)', marginBottom:10, textTransform:'uppercase' }}>Status</div>
              <div style={{ display:'flex', gap:8 }}>
                {['Agendado','Realizado','No-show','Cancelado'].map(s => (
                  <button key={s} onClick={() => mudarStatus(eventoAberto.id, s)}
                    style={{ padding:'6px 12px', borderRadius:20, border:`1px solid ${eventoAberto.status===s?'var(--purple)':'var(--border)'}`, background:eventoAberto.status===s?'var(--purple)':'transparent', color:eventoAberto.status===s?'white':'var(--text-secondary)', cursor:'pointer', fontSize:11, fontWeight:eventoAberto.status===s?700:400 }}>
                    {s}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal editar evento */}
      {modalEditarEvento && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:2000 }}>
          <div className="card" style={{ width:480, padding:32, maxHeight:'90vh', overflowY:'auto' }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:20 }}>
              <h3 style={{ margin:0, color:'var(--purple)' }}>Editar Evento</h3>
              <button onClick={() => setModalEditarEvento(false)} style={{ background:'transparent', border:'none', fontSize:20, cursor:'pointer', color:'var(--gray-400)' }}>×</button>
            </div>
            {[{label:'Título',key:'titulo',type:'text'},{label:'Data',key:'data',type:'date'},{label:'Hora',key:'hora',type:'time'}].map(f => (
              <div key={f.key} style={{ marginBottom:14 }}>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>{f.label}</label>
                <input type={f.type} value={formEditar[f.key]||''} onChange={e => setFormEditar({...formEditar,[f.key]:e.target.value})}
                  style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box' }} />
              </div>
            ))}
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Projeto (opcional)</label>
              <select value={formEditar.projeto||''} onChange={e => setFormEditar({...formEditar,projeto:e.target.value})}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)' }}>
                <option value=''>— Sem projeto —</option>
                {projetosCad.map(p => <option key={p.id} value={p.nome}>{p.nome}</option>)}
              </select>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Tipo</label>
              <select value={formEditar.tipo||'call'} onChange={e => setFormEditar({...formEditar,tipo:e.target.value})}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)' }}>
                {Object.entries(TIPOS).map(([k,v]) => <option key={k} value={k}>{v.emoji} {v.label}</option>)}
              </select>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Status</label>
              <select value={formEditar.status||'Agendado'} onChange={e => setFormEditar({...formEditar,status:e.target.value})}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)' }}>
                {['Agendado','Realizado','No-show','Cancelado'].map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div style={{ marginBottom:20 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Observações</label>
              <textarea value={formEditar.obs||''} onChange={e => setFormEditar({...formEditar,obs:e.target.value})} rows={2}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box', resize:'vertical' }} />
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={salvarEdicaoEvento} style={{ flex:1, background:'var(--purple)', color:'white', border:'none', padding:'11px', borderRadius:7, fontWeight:700, cursor:'pointer', fontSize:14 }}>Salvar</button>
              <button onClick={() => setModalEditarEvento(false)} style={{ flex:1, background:'transparent', border:'1px solid var(--border)', padding:'11px', borderRadius:7, cursor:'pointer', color:'var(--text-secondary)', fontSize:14 }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal novo evento */}
      {modalAberto && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div className="card" style={{ width:480, padding:32, maxHeight:'90vh', overflowY:'auto' }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:20 }}>
              <h3 style={{ margin:0, color:'var(--purple)' }}>Novo Evento</h3>
              <button onClick={() => setModalAberto(false)} style={{ background:'transparent', border:'none', fontSize:20, cursor:'pointer', color:'var(--gray-400)' }}>×</button>
            </div>
            {[{label:'Título',key:'titulo',type:'text'},{label:'Data',key:'data',type:'date'},{label:'Hora',key:'hora',type:'time'}].map(f => (
              <div key={f.key} style={{ marginBottom:14 }}>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>{f.label}</label>
                <input type={f.type} value={form[f.key]} onChange={e => setForm({...form,[f.key]:e.target.value})}
                  style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box' }} />
              </div>
            ))}
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Projeto (opcional)</label>
              <select value={form.projeto||''} onChange={e => setForm({...form,projeto:e.target.value})}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)' }}>
                <option value=''>— Sem projeto —</option>
                {projetosCad.map(p => <option key={p.id} value={p.nome}>{p.nome}</option>)}
              </select>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Tipo</label>
              <select value={form.tipo} onChange={e => setForm({...form,tipo:e.target.value})}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)' }}>
                {Object.entries(TIPOS).map(([k,v]) => <option key={k} value={k}>{v.emoji} {v.label}</option>)}
              </select>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:8, textTransform:'uppercase' }}>Responsáveis</label>
              <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                {colaboradores.map(c => {
                  const ativo = form.responsaveis.includes(c.nome);
                  return <div key={c.nome} onClick={() => toggleResponsavel(c.nome)} style={{ display:'flex', alignItems:'center', gap:6, padding:'6px 12px', borderRadius:20, border:`2px solid ${ativo?(c.cor||'var(--purple)'):'var(--border)'}`, background:ativo?(c.cor||'var(--purple)')+'33':'transparent', cursor:'pointer' }}>
                    <div style={{ width:18, height:18, borderRadius:'50%', background:c.cor||'var(--purple)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:8, fontWeight:700, color:'white' }}>{iniciais(c.nome)}</div>
                    <span style={{ fontSize:12, fontWeight:ativo?700:400 }}>{c.nome.split(' ')[0]}</span>
                  </div>;
                })}
              </div>
            </div>
            <div style={{ marginBottom:20 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Observações</label>
              <textarea value={form.obs} onChange={e => setForm({...form,obs:e.target.value})} rows={2}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box', resize:'vertical' }} />
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={salvarEvento} style={{ flex:1, background:'var(--purple)', color:'white', border:'none', padding:'11px', borderRadius:7, fontWeight:700, cursor:'pointer', fontSize:14 }}>Salvar</button>
              <button onClick={() => setModalAberto(false)} style={{ flex:1, background:'transparent', border:'1px solid var(--border)', padding:'11px', borderRadius:7, cursor:'pointer', color:'var(--text-secondary)', fontSize:14 }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal lembrete */}
      {modalLembrete && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div className="card" style={{ width:440, padding:32 }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:20 }}>
              <h3 style={{ margin:0, color:'#E05454' }}>🔔 Enviar Lembrete</h3>
              <button onClick={() => setModalLembrete(false)} style={{ background:'transparent', border:'none', fontSize:20, cursor:'pointer', color:'var(--gray-400)' }}>×</button>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Para quem</label>
              <select value={formLembrete.destinatario} onChange={e => setFormLembrete({...formLembrete,destinatario:e.target.value})}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)' }}>
                <option value=''>Selecionar...</option>
                {colaboradores.filter(c=>c.nome!==usuarioAtual).map(c => <option key={c.nome} value={c.nome}>{c.nome}</option>)}
              </select>
            </div>
            {[{label:'Título',key:'titulo',type:'text'},{label:'Data',key:'data',type:'date'},{label:'Hora',key:'hora',type:'time'}].map(f => (
              <div key={f.key} style={{ marginBottom:14 }}>
                <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>{f.label}</label>
                <input type={f.type} value={formLembrete[f.key]} onChange={e => setFormLembrete({...formLembrete,[f.key]:e.target.value})}
                  style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box' }} />
              </div>
            ))}
            <div style={{ marginBottom:20 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Mensagem</label>
              <textarea value={formLembrete.obs} onChange={e => setFormLembrete({...formLembrete,obs:e.target.value})} rows={3}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box', resize:'vertical' }} />
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={enviarLembrete} style={{ flex:1, background:'#E05454', color:'white', border:'none', padding:'11px', borderRadius:7, fontWeight:700, cursor:'pointer', fontSize:14 }}>Enviar</button>
              <button onClick={() => setModalLembrete(false)} style={{ flex:1, background:'transparent', border:'1px solid var(--border)', padding:'11px', borderRadius:7, cursor:'pointer', color:'var(--text-secondary)', fontSize:14 }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
